import { ContentBlockProperties, ContentMode } from "../types/ThemeTypes";

type ContentProps = Partial<ContentBlockProperties> | undefined;

/**
 * What the Content block shows: media or embed HTML, per the CMS toggle.
 * Configs saved before the toggle have no `contentMode`; they showed embed
 * HTML whenever any was set, so they keep doing that.
 *
 * Keep in sync with fe-client-swiift-studio
 * `src/pages/theme-design/utils/contentEmbed.ts`.
 */
export const resolveContentMode = (props: ContentProps): ContentMode => {
  if (props?.contentMode === "media" || props?.contentMode === "embedHtml") {
    return props.contentMode;
  }
  return props?.htmlCode?.trim() || props?.htmlCodeMobile?.trim()
    ? "embedHtml"
    : "media";
};

/**
 * The embed HTML for this view, or "" — in Embed HTML mode only. Mobile/tablet
 * use the mobile embed, falling back to the large-screen one.
 */
export const resolveEmbedHtml = (
  props: ContentProps,
  isMobileView: boolean
): string => {
  if (resolveContentMode(props) !== "embedHtml") return "";
  return (
    (isMobileView
      ? props?.htmlCodeMobile?.trim() || props?.htmlCode?.trim()
      : props?.htmlCode?.trim()) || ""
  );
};
